module.exports = __webpack_public_path__ + "static/goerges-gray-a1baa9f0f33546f717a5301959208e46.png";